import { render, staticRenderFns } from "./ProductDetailsHeader.vue?vue&type=template&id=351e5a9f"
import script from "./ProductDetailsHeader.vue?vue&type=script&lang=js"
export * from "./ProductDetailsHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports